import { DateUtils, dateUtils } from 'shared_DEPRECATED/utils';

import { AudioRecorderResult, AudioRecorderStopResult } from './types';

const MEDIA_RECORDER_EVENTS = {
  DATA_AVAILABLE: 'dataavailable', // called after recorder has stopped recording
  STOP: 'stop', // called after calling mediaRecorder.stop();
} as const;

export class AudioRecorder {
  private mediaRecorder: MediaRecorder | null = null;
  private mediaStream: MediaStream | null = null;
  private audioBlobs: Blob[] = [];
  private recordingStart: DateUtils | null = null;
  private duration: number | null = null;

  constructor(mediaStream: MediaStream) {
    this.audioBlobs = [];
    this.mediaRecorder = new MediaRecorder(mediaStream, {
      mimeType: 'audio/mp4;codecs=mp4a.40.2',
    });
    this.mediaStream = mediaStream;
    this.mediaRecorder?.addEventListener(
      MEDIA_RECORDER_EVENTS.DATA_AVAILABLE,
      this.handleDataAvailable
    );
  }

  start = () => {
    this.mediaRecorder?.start();
    this.recordingStart = dateUtils();
  };

  stop = (): AudioRecorderStopResult => {
    return new Promise((resolve) => {
      this.mediaRecorder?.addEventListener(MEDIA_RECORDER_EVENTS.STOP, () => {
        const audioBlob = new Blob(this.audioBlobs, {
          type: 'audio/mp4',
        });
        this.reset();
        resolve({
          duration: dateUtils().diff(this.recordingStart!.toDate(), 'second'), // return duration of recording in seconds
          blob: audioBlob,
        });
      });
      this.mediaRecorder?.stop();
    });
  };

  getRecordingInfo = (): AudioRecorderResult => {
    const audioBlob = new Blob(this.audioBlobs, {
      type: 'audio/mp4',
    });

    return {
      duration: this.duration!,
      blob: audioBlob,
    };
  };

  pause = (): void => {
    this.mediaRecorder?.stop();
    this.stopStream();
    this.duration = dateUtils().diff(this.recordingStart!.toDate(), 'second');
  };

  handleDataAvailable = (event: BlobEvent) => {
    this.audioBlobs.push(event.data);
  };

  cancel = () => {
    this.mediaRecorder?.stop();
    this.reset();
  };

  stopStream = () => {
    this.mediaStream?.getTracks().forEach((track) => {
      track.stop();
    });
  };

  reset = () => {
    this.stopStream();
    this.mediaRecorder?.removeEventListener(
      MEDIA_RECORDER_EVENTS.DATA_AVAILABLE,
      this.handleDataAvailable
    );
    this.mediaRecorder = null;
    this.mediaStream = null;
    this.audioBlobs = [];
  };
}
